import axios from "axios";

const baseUrl = process.env.REACT_APP_MAIN_API_Url;

const LoggerService = {
  getLogs: async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/logger`);
      return response.data;
    } catch (error) {
      console.error("Error fetching logs", error);
      throw error;
    }
  },

  generateError: async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/logger/generate-error`);
      return response.data;
    } catch (error) {
      console.error("Error generating error", error);
      throw error;
    }
  },

  deleteLogs: async () => {
    try {
      const response = await axios.delete(`${baseUrl}/api/logger/delete-logs`);
      return response.data;
    } catch (error) {
      console.error("Error deleting logs", error);
      throw error;
    }
  },

  // Enhanced system resources with Redis and Meeting metrics
  getSystemResources: async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/resourcemonitor/resources`);
      
      // Log the response for debugging
      console.log("Resource Monitor Response:", response.data);
      
      // Ensure we have the expected structure
      const data = response.data;
      
      // Validate Redis data exists
      if (data.redis) {
        console.log("Redis metrics found:", data.redis);
      } else {
        console.warn("Redis metrics not found in response");
      }
      
      // Validate Meeting data exists
      if (data.meetings) {
        console.log("Meeting metrics found:", data.meetings);
      } else {
        console.warn("Meeting metrics not found in response");
      }
      
      return data;
    } catch (error) {
      console.error("Error fetching system resources", error);
      throw error;
    }
  },

  checkResources: async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/resourcemonitor/check`);
      return response.data;
    } catch (error) {
      console.error("Error checking resources", error);
      throw error;
    }
  },

  // NEW: Get Redis-specific metrics
  getRedisStatus: async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/resourcemonitor/redis-status`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Redis status", error);
      throw error;
    }
  },

  // NEW: Get Meeting-specific metrics
  getMeetingMetrics: async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/resourcemonitor/meeting-metrics`);
      return response.data;
    } catch (error) {
      console.error("Error fetching meeting metrics", error);
      throw error;
    }
  },

  // Enhanced resource checking with meeting-specific alerts
  checkResourcesEnhanced: async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/resourcemonitor/check`);
      
      // Also check if we need to trigger meeting-specific alerts
      const resources = await this.getSystemResources();
      
      // Client-side meeting capacity warnings
      if (resources.meetings && resources.meetings.concurrentMeetings >= 8) {
        console.warn(`High meeting load detected: ${resources.meetings.concurrentMeetings} concurrent meetings`);
      }
      
      if (resources.redis && !resources.redis.isConnected) {
        console.error("Redis connection lost - meeting data may be at risk");
      }
      
      return response.data;
    } catch (error) {
      console.error("Error in enhanced resource checking", error);
      throw error;
    }
  }
};

export default LoggerService;




// import axios from "axios";

// const baseUrl = process.env.REACT_APP_MAIN_API_Url;

// const LoggerService = {
//   getLogs: async () => {
//     try {
//       const response = await axios.get(`${baseUrl}/api/logger`);
//       return response.data;
//     } catch (error) {
//       console.error("Error fetching logs", error);
//       throw error;
//     }
//   },

//   generateError: async () => {
//     try {
//       const response = await axios.get(`${baseUrl}/api/logger/generate-error`);
//       return response.data;
//     } catch (error) {
//       console.error("Error generating error", error);
//       throw error;
//     }
//   },

//   deleteLogs: async () => {
//     try {
//       const response = await axios.delete(`${baseUrl}/api/logger/delete-logs`);
//       return response.data;
//     } catch (error) {
//       console.error("Error deleting logs", error);
//       throw error;
//     }
//   },


//   // Add these new methods
//   getSystemResources: async () => {
//     try {
//       const response = await axios.get(`${baseUrl}/api/resourcemonitor/resources`);
//       return response.data;
//     } catch (error) {
//       console.error("Error fetching system resources", error);
//       throw error;
//     }
//   },

//   checkResources: async () => {
//     try {
//       const response = await axios.post(`${baseUrl}/api/resourcemonitor/check`);
//       return response.data;
//     } catch (error) {
//       console.error("Error checking resources", error);
//       throw error;
//     }
//   },
// };

// export default LoggerService;